/** @format */

import { axiosCalls } from '../../config/AxiosCall';
import { SendVerificationCode, loginDto } from './models';

const url = 'Accounts';

export async function login(payload: loginDto) {
  return axiosCalls.post(payload, `${url}/login`);
}

export async function GetOtp(identityNumber: string) {
  return axiosCalls.post(
    identityNumber,
    `${url}/generate-otp?identityNumber=${identityNumber}`
  );
}

export async function VerifyOtp(payload: SendVerificationCode) {
  return axiosCalls.post(
    payload,
    `${url}/verify-otp?otp=${payload.otp}&identityNumber=${payload.identityNumber}`
  );
}
